import { render, staticRenderFns } from "./JdrComponent.vue?vue&type=template&id=32356ace&scoped=true"
import script from "./JdrComponent.vue?vue&type=script&lang=ts"
export * from "./JdrComponent.vue?vue&type=script&lang=ts"
import style0 from "./JdrComponent.vue?vue&type=style&index=0&id=32356ace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32356ace",
  null
  
)

export default component.exports